import { ButtonBase, Typography } from '@material-ui/core'

import { LocalizedLink } from '../../routes/localizedRoutes'
import { PaymentTermBrief } from '../../types/walletPaymentTerm'
import useStyles from './styles/PaymentTermRow.styles'

interface TenantRowProps {
  data: PaymentTermBrief
}
const TenantRow: React.FC<TenantRowProps> = ({ data }) => {
  const { name, displayPaymentTermCode, paymentTermID } = data

  const classes = useStyles()

  return (
    <div className={classes.tableRowRoot}>
      <ButtonBase
        className={classes.tableRow}
        component={LocalizedLink}
        to={`/adopay/payment-term/${paymentTermID}/details`}>
        <div className={classes.nameCell}>
          <Typography variant="h4">{name}</Typography>
        </div>
        <div>
          <Typography variant="body1" className={classes.code}>
            {displayPaymentTermCode}
          </Typography>
        </div>
      </ButtonBase>
    </div>
  )
}
export default TenantRow
